import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph, Heading1, Heading2, LinkStyled, List, Bold,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Sodavand" activeSidemenu="FremSodavand">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Billig Frem sodavand</Heading1>
          <Paragraph>
            Den danske, velsmagende sodavand er kendt for sloganet: “Alle på stribe, drikker Frem fra Ribe.” Hos Skafte tilbyder vi mange skønne varianter af Frem sodavand, som du let kan slukke tørsten i.
          </Paragraph>
          <Paragraph>
            Frem sodavand leveres i 25 cl pantflasker i kasser med 24 stk. Kan du lide at nyde en kold sodavand fra glasflaske, så kan du med fordel også købe Frem sodavand, da det er det eneste danske tapperi, der stadig laver billige sodavand på glasflaske.
          </Paragraph>
          <Paragraph>
            Køb 5 kasser Frem sodavand og få gratis levering i Storkøbenhavn og omegn.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fremSodavand" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white>
      <Row>
        <Col xs={12} sm={6} md={6}>
          <Paragraph>
            Priserne er uden pant<br />
            Panten er 80 øre + moms = 1,00 kr. med moms pr. flaske.<br />
            Panten på kassen er 10,00 kr. + moms = 12,50 kr. med moms pr. kasse.<br />
            I alt for flasker og kasse er panten 36,50 kr med moms pr. kasse.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Alle på stribe drikker Frem fra Ribe</Heading2>
          <Paragraph>
            Frem sodavand startede sin rejse i 1956 i Helsingør, hvor den hurtigt fandt vej til danskerens hjerte. Med en kombination af lokale råvarer og en dyb forståelse for det danske smagsunivers, har Frem gennem tiderne formået at skabe drikkevarer, der føles både nostalgiske og tidløse på én og samme tid.
          </Paragraph>
          <Paragraph>
            Mangler du også en god sodavand at slukke tørsten i? Eller en lidt ekstra lækker sodavand at nyde i weekenden? Så find din yndlings variant af Frem sodavand lige her. Banker hjertet stadig også for de helt klassiske sodavand, som vi alle kender? Så se vores store udvalg af <LinkStyled to="/sodavand">sodavand</LinkStyled>, hvor du finder alle de store mærker og kendte varianter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Find din favorit Frem sodavand</Heading2>
          <Paragraph>
            Der er smagsvarianter for alle! Hvad enten du er til den klassiske appelsinsodavand, den forfriskende citronbrus, eller måske en mere eksotisk tropisk variant, har Frem noget for alle smagsløg. Hver variant er skabt med omhu og dedikation for at sikre, at hver slurk er en oplevelse i sig selv.
          </Paragraph>
          <Paragraph>
            Vælg mellem følgende varianter af Frem sodavand:
          </Paragraph>
          <List>
            <li>Frem danskvand</li>
            <li>Frem danskvand med citrus</li>
            <li>Frem hyldeblomst saft</li>
            <li>Frem appelsin light</li>
            <li>Frem Blå Sport</li>
            <li>Frem Grøn Sport</li>
            <li>Frem Energisten</li>
            <li>Frem appelsin</li>
            <li>Frem ananas</li>
            <li>Frem abrikos</li>
            <li>Frem hindbær</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Derfor skal du vælge Frem sodavand</Heading2>
          <Paragraph>
            Der er flere gode grunde til at vælge en frem sodavand - udover smagen!
          </Paragraph>
          <List>
            <li><Bold>Tradition møder innovation: </Bold>Selvom Frem sodavand er dybt forankret i traditionelle værdier og smage, er de ikke bange for at eksperimentere og komme med nye spændende varianter.</li>
            <li><Bold>Lokale ingredienser: </Bold>Frem sodavand har altid haft fokus på at bruge kvalitetsråvarer, og hvor det er muligt, kommer de fra lokale leverandører.</li>
            <li><Bold>For alle aldre: </Bold>Med sin brede vifte af smagsvarianter appellerer Frem sodavand til både børn og voksne, hvilket gør det til det perfekte valg for enhver anledning.</li>
          </List>
          <Paragraph>
            Næste gang du står og skal vælge en sodavand, hvorfor så ikke lade valget falde på en Frem sodavand? Med sin rige historie, lækre smagsnuancer og dedikation til kvalitet, er det ikke bare en sodavand – det er en del af den danske drikkekultur.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Køb Frem sodavand hos Skafte</Heading2>
          <Paragraph>
            Hvis du er lige så vild med Frem sodavand som vi er, så er du havnet det helt rette sted! Her på siden finder du et bredt udvalg og kan vælge netop de varianter, som du ikke kan undvære derhjemme eller på arbejdspladsen.
          </Paragraph>
          <Paragraph>
            Vi tilbyder hurtig levering - og du får endda gratis levering i Storkøbenhavn og omegn, hvis du bestiller 5 kasser Frem sodavand.
          </Paragraph>
          <Paragraph>
            Som Frem sodavand forhandler tilbyder vi, at du kan købe hele kasser, frem for enkelte flasker ad gangen. Dette gør det ikke kun lettere at stable derhjemme eller på arbejdspladsen, men gør det også lidt lettere altid at have adgang til en kold og forfriskende dansk sodavand.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
